import { first, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Batch } from '../_models/batch';

@Injectable()
export class BatchService {
  private apiBaseUrl = environment.apiBaseUrl;
  ItemObj: BehaviorSubject<Batch> = new BehaviorSubject<Batch>(null);
  list: BehaviorSubject<Array<Batch>> = new BehaviorSubject<Array<Batch>>(null);

  constructor(private http: HttpClient) {}

  getBatches(): Observable<Batch[]> {
    return this.http.get<any>(this.apiBaseUrl + 'api/private/v1/batches').pipe(
      map((response) => {
        if (response) {
          this.list.next(response);
          return response;
        }

        return [];
      })
    );
  }

  getBatch(id: number): Observable<Batch> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v1/batches/' + id)
      .pipe(map((response) => response));
  }

  saveBatch(batchItem): Observable<Batch> {
    const batch = { ...batchItem };
    delete batch.lastUpdated;
    delete batch.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    batch.companyId = companySelected ? companySelected.id : null;

    if (batch.user != null && batch.user.id != null) {
      batch.user = { id: batch.user.id };
    }
    if (batch.id) {
      return this.http
        .put<Batch>(this.apiBaseUrl + 'api/private/v1/batches/' + batch.id, batch)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Batch>(this.apiBaseUrl + 'api/private/v1/batches', batch)
        .pipe(map((response) => response));
    }
  }

  getLocalBatchById = (id: number): Batch => {
    let item: Batch;
    this.list.pipe(first((list: Batch[]) => list && list.length > 0)).subscribe((list: Batch[]) => {
      item = list.find((i) => i.id === id);
    });
    return item;
  };

  deleteBatch(batch: Batch): Observable<Batch> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/batches/' + batch.id).pipe(
      map(() => {
        return { id: batch.id } as Batch;
      })
    );
  }
}
